// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qx_H","icon":"styles_icon__NN_n8","gb":"styles_gb__1PxMi"};